import type { RouteParamsRequest } from '@pba/react-utils';
import { type ApiClientResponse, apiClient, routes } from 'common/services';
import type { WithingsOrderPostContentObjectDetailDataObject } from 'models/service';

export const getOrderPost = async ({ routeParams: { id } }: RouteParamsRequest<{ id: string }>) =>
  apiClient.get<
    WithingsOrderPostContentObjectDetailDataObject,
    ApiClientResponse<WithingsOrderPostContentObjectDetailDataObject>
  >(routes.withings.getOrderPost(id));
